import {
  Airplane,
  AppWindow,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowSquareOut,
  ArrowsClockwise,
  ArrowsDownUp,
  ArrowsOut,
  ArrowsOutSimple,
  ArrowUp,
  Backspace,
  BatteryCharging,
  BatteryHigh,
  Buildings,
  Calendar,
  CalendarBlank,
  Car,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  CaretUpDown,
  Carrot,
  CarSimple,
  ChargingStation,
  ChartLine,
  Check,
  CheckCircle,
  Circle,
  CircleNotch,
  City,
  ClipboardText,
  ClockCounterClockwise,
  CloudLightning,
  Code,
  Columns,
  Command,
  Compass,
  Copy,
  Cpu,
  Cube,
  DeviceMobile,
  Devices,
  Diamond,
  DotsSixVertical,
  DotsThree,
  DotsThreeVertical,
  DownloadSimple,
  Drop,
  DropHalfBottom,
  Empty,
  Envelope,
  Export,
  Eye,
  EyeSlash,
  Flag,
  Flame,
  FlowArrow,
  GasPump,
  Gauge,
  Ghost,
  GridFour,
  House,
  Image,
  Infinity as InfinityIcon,
  Info,
  LightbulbFilament,
  Lightning,
  List,
  ListBullets,
  ListDashes,
  ListNumbers,
  MagnifyingGlass,
  MapPin,
  MapPinArea,
  Minus,
  Monitor,
  Moon,
  NavigationArrow,
  Palette,
  PaperclipHorizontal,
  Pause,
  PencilSimple,
  Phone,
  Placeholder,
  Play,
  Plug,
  Plus,
  Power,
  Question,
  Radio,
  RocketLaunch,
  Share,
  ShareNetwork,
  ShieldCheck,
  Sidebar,
  Sliders,
  Snowflake,
  Sparkle,
  Spinner,
  Stack,
  Star,
  Sun,
  Table,
  Tabs,
  Target,
  Thermometer,
  ThermometerSimple,
  Tray,
  TreeStructure,
  TrendUp,
  Upload,
  User,
  Users,
  Warehouse,
  Warning,
  WifiHigh,
  Wind,
  XCircle,
} from "@phosphor-icons/react";

export const commonPhosphorIcons = {
  Airplane,
  AppWindow,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowSquareOut,
  ArrowUp,
  ArrowsClockwise,
  ArrowsDownUp,
  ArrowsOut,
  ArrowsOutSimple,
  Backspace,
  BatteryCharging,
  BatteryHigh,
  Buildings,
  Calendar,
  CalendarBlank,
  Car,
  CarSimple,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  CaretUpDown,
  Carrot,
  ChargingStation,
  ChartLine,
  Check,
  CheckCircle,
  Circle,
  CircleNotch,
  City,
  ClipboardText,
  ClockCounterClockwise,
  CloudLightning,
  Code,
  Columns,
  Command,
  Compass,
  Copy,
  Cpu,
  Cube,
  DeviceMobile,
  Devices,
  Diamond,
  DotsSixVertical,
  DotsThree,
  DotsThreeVertical,
  DownloadSimple,
  Drop,
  DropHalfBottom,
  Empty,
  Envelope,
  Export,
  Eye,
  EyeSlash,
  Flag,
  Flame,
  FlowArrow,
  GasPump,
  Gauge,
  Ghost,
  GridFour,
  House,
  Image,
  Infinity: InfinityIcon,
  Info,
  LightbulbFilament,
  Lightning,
  List,
  ListBullets,
  ListDashes,
  ListNumbers,
  MagnifyingGlass,
  MapPin,
  MapPinArea,
  Minus,
  Monitor,
  Moon,
  NavigationArrow,
  Palette,
  PaperclipHorizontal,
  Pause,
  PencilSimple,
  Phone,
  Placeholder,
  Play,
  Plug,
  Plus,
  Power,
  Question,
  Radio,
  RocketLaunch,
  Share,
  ShareNetwork,
  ShieldCheck,
  Sidebar,
  Sliders,
  Snowflake,
  Sparkle,
  Spinner,
  Stack,
  Star,
  Sun,
  Table,
  Tabs,
  Target,
  Thermometer,
  ThermometerSimple,
  Tray,
  TreeStructure,
  TrendUp,
  Upload,
  User,
  Users,
  Warehouse,
  Warning,
  WifiHigh,
  Wind,
  XCircle,
};
